export const SET_COLOR = 'SET_COLOR';